import {
  ILoginRequest,
  ICheckPasswordRequest,
  IResetPasswordRequest,
  IChangePasswordRequest,
  IUser,
} from '../../interfaces/auth.interface';

export namespace Auth {
  export class Login {
    static readonly type = '[Auth] Login';
    constructor(public payload: ILoginRequest) {}
  }

  export class LoginSuccess {
    static readonly type = '[Auth] Login Success';
    constructor(public payload: any) {}
  }

  export class LoginFailure {
    static readonly type = '[Auth] Login Failure';
    constructor(public error: any) {}
  }

  export class Logout {
    static readonly type = '[Auth] Logout';
  }

  export class LogoutTransportista {
    static readonly type = '[Auth] Logout Transportista';
  }

  export class LogoutSuccess {
    static readonly type = '[Auth] Logout Success';
  }

  export class ForgotPassword {
    static readonly type = '[Auth] Forgot Password';
    constructor(public payload: ICheckPasswordRequest) {}
  }

  export class ForgotPasswordReset {
    static readonly type = '[Auth] Forgot Password Reset';
  }

  export class ResetPassword {
    static readonly type = '[Auth] Reset Password';
    constructor(public payload: IResetPasswordRequest) {}
  }

  export class ChangePassword {
    static readonly type = '[Auth] Change Password';
    constructor(public payload: IChangePasswordRequest) {}
  }

  export class ResetPasswordClear {
    static readonly type = '[Auth] Reset Password Clear';
  }

  export class SetUser {
    static readonly type = '[Auth] Set User';
    constructor(public user: IUser) {}
  }

  export class PermissionsChanged {
    static readonly type = '[Auth] Permissions Changed';
  }

  export class ChangePasswordClear {
    static readonly type = '[Auth] Change Password Clear';
  }

  
}
